import { FiInstagram, FiFacebook, FiTwitter } from "react-icons/fi";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <span className="footer__brand">MERCANTILE</span>
        <p className="footer__copy">
          © {new Date().getFullYear()} — built by Yacine Ahmed Adel
        </p>
        <div className="footer__social">
          <a href="/" aria-label="Instagram">
            <FiInstagram size={18} />
          </a>
          <a href="/" aria-label="Facebook">
            <FiFacebook size={18} />
          </a>
          <a href="/" aria-label="Twitter">
            <FiTwitter size={18} />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
